import { defineStyle, defineStyleConfig } from "@chakra-ui/react";
import { Input } from "./Input";

const brand = defineStyle(() => {
  return Input.variants?.brand.field ?? {};
});

export const PinInput = defineStyleConfig({ variants: { brand } });
